import clsx from 'clsx';

/** A provider's inline SVG as an image: `<img>` can't run a script a vendor's markup might carry, which inlining it would. */
export function IntegrationLogo({ logoSvg, name, className }: { logoSvg: string; name: string; className?: string }) {
  return (
    <img src={`data:image/svg+xml,${encodeURIComponent(logoSvg)}`} alt={`${name} logo`} className={clsx('size-10 rounded-md object-contain', className)} />
  );
}
